import { Observable, of, zip as observableZip } from 'rxjs';
import { Injectable } from '@angular/core'
import { Actions, Effect } from '@ngrx/effects'
import { Action, select, Store } from '@ngrx/store'
import { map, switchMap, withLatestFrom } from 'rxjs/operators'

import * as meta from '../actions/meta'
import * as facet from '../actions/facets'

import * as fromOrders from '../reducers'

@Injectable()
export class MetaEffects {
    constructor(
        private actions$: Actions,
        private store: Store<fromOrders.State>
    ) { }

    @Effect()
    metaInitRun$: Observable<Action> = 
        this.actions$.ofType<meta.Init>(meta.INIT)
            .pipe(
                withLatestFrom(
                    this.store.pipe(select(fromOrders.isInitialized)),
                    (action, initialized) => initialized 
                ),
                switchMap(initialized => {
                    if(initialized)
                        return of(new meta.InitSkipped())
                    return of(
                        new facet.InitGroups() as Action,
                        new facet.InitFacets()
                    )
                })
            )

    @Effect()
    metaInitComplete$: Observable<Action> = 
        observableZip(
            this.actions$.ofType<Action>(facet.INIT_GROUPS_SUCCESS, facet.INIT_GROUPS_FAILED),
            this.actions$.ofType<Action>(facet.INIT_FACETS_SUCCESS, facet.INIT_FACETS_FAILED)
        ).pipe(
            map((actions: [Action, Action]) => {
                let failed = actions.some(
                    action => action.type == facet.INIT_GROUPS_FAILED
                    || action.type == facet.INIT_FACETS_FAILED
                )

                if(failed)
                    return new meta.InitFailed()
                return new meta.InitSuccess()
            })
        )
}
